import { isMobileWebview } from './isMobileWebview';

export const eventsTracker = (eventData: any, posthog?: any) => {
  if (
    isMobileWebview() &&
    window?.niyo_ct_event_tracking &&
    typeof window.niyo_ct_event_tracking === 'function'
  ) {
    const stringifiedEventData = JSON.stringify(eventData);
    window.niyo_ct_event_tracking(stringifiedEventData);
    if (window.location.href.includes('goniyo.com')) {
      posthog.capture(eventData?.screenName + '_' + eventData?.ctaAction, eventData);
    }
  }
};
